
import { computed, defineComponent, PropType } from 'vue'
import BillingTemplatesFormFieldTemplateName from '@/components/billing-templates/form-fields/template-name.vue'
import BillingTemplatesFormFieldOrganizationName from '@/components/billing-templates/form-fields/organization-name.vue'
import BillingTemplatesFormFieldStreet from '@/components/billing-templates/form-fields/street.vue'
import BillingTemplatesFormFieldCity from '@/components/billing-templates/form-fields/city.vue'
import BillingTemplatesFormFieldZip from '@/components/billing-templates/form-fields/zip.vue'
import BillingTemplatesFormFieldCountry from '@/components/billing-templates/form-fields/country.vue'
import BillingTemplatesFormFieldContactEmail from '@/components/billing-templates/form-fields/contact-email.vue'
import BillingTemplatesFormFieldContactName from '@/components/billing-templates/form-fields/contact-name.vue'
import BillingTemplatesFormFieldVatId from '@/components/billing-templates/form-fields/vat-id.vue'
import BillingTemplatesFormFieldCustomerNumber from '@/components/billing-templates/form-fields/customer-number.vue'
import BillingTemplatesFormFieldReference from '@/components/billing-templates/form-fields/reference.vue'
import BillingTemplatesFormFieldBusinessId from '@/components/billing-templates/form-fields/business-id.vue'
import { BasicBillingTemplate } from '@/modules/billing-templates/types'
import { useOrganizationModule } from '@/modules/organizations'
import { useRoute } from 'vue-router'
import BillingTemplatesFormFieldPaymentTerms from '@/components/billing-templates/form-fields/payment-terms.vue'
import BillingTemplatesFormFieldInvoiceDescription
    from '@/components/billing-templates/form-fields/invoice-description.vue'

export default defineComponent({
    name: 'billing-templates-basic-billing-template-form-part',
    components: {
        BillingTemplatesFormFieldInvoiceDescription,
        BillingTemplatesFormFieldPaymentTerms,
        BillingTemplatesFormFieldTemplateName,
        BillingTemplatesFormFieldOrganizationName,
        BillingTemplatesFormFieldBusinessId,
        BillingTemplatesFormFieldStreet,
        BillingTemplatesFormFieldCity,
        BillingTemplatesFormFieldZip,
        BillingTemplatesFormFieldCountry,
        BillingTemplatesFormFieldContactEmail,
        BillingTemplatesFormFieldContactName,
        BillingTemplatesFormFieldVatId,
        BillingTemplatesFormFieldCustomerNumber,
        BillingTemplatesFormFieldReference
    },
    props: {
        modelValue: {
            type: Object as PropType<BasicBillingTemplate>,
            required: true
        },
        showTemplateName: {
            type: Boolean,
            default: true
        }
    },
    setup (props, { emit }) {
        const route = useRoute()
        const { getOrganization } = useOrganizationModule()
        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })
        const copyFromOrganization = async () => {
            const organizationId = route.params.organizationId as string
            const org = await getOrganization(organizationId)
            const v = localModel.value
            v.businessId = org.businessId
            v.organizationName = org.companyName
            v.contactPersonName = org.contactName || v.contactPersonName
            v.contactPersonEmail = org.contactEmail || v.contactPersonEmail
            v.customerNumber = org.customerNumber || v.customerNumber
            v.vatId = org.vatId || v.vatId
        }

        return {
            localModel,
            copyFromOrganization
        }
    }
})
